import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M47.7701 12.4C43.2301 5.64002 32.9802 1.64001 27.0302 1.64001C21.0702 1.64001 10.7301 5.64002 6.20014 12.4C-1.92986 24.51 3.61011 45.64 3.61011 45.64C3.61011 45.64 4.16014 21.4299 10.2601 15.0499C15.4501 9.60993 20.2201 14.33 26.9801 14.33C33.7501 14.33 38.5101 9.61993 43.7001 15.0499C49.8001 21.4399 50.3501 45.64 50.3501 45.64C50.3501 45.64 55.9001 24.51 47.7701 12.4Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M21.4601 2.88003C21.4601 2.88003 19.3801 2.32002 22.2901 14.37" stroke={outline} strokeMiterlimit="10" />
      <path d="M15.0902 5.34998C15.0902 5.34998 11.9302 6.43999 14.2602 12.99" stroke={outline} strokeMiterlimit="10" />
      <path d="M12.1802 7.17004C12.1802 7.17004 8.02018 8.3 9.55018 16.13" stroke={outline} strokeMiterlimit="10" />
      <path d="M5.90014 13.0599C5.90014 13.0599 1.23013 18.17 5.39013 29.89" stroke={outline} strokeMiterlimit="10" />
      <path d="M32.4902 2.88003C32.4902 2.88003 34.5702 2.32002 31.6602 14.37" stroke={outline} strokeMiterlimit="10" />
      <path d="M38.8601 5.34998C38.8601 5.34998 41.8601 6.14999 39.6901 12.99" stroke={outline} strokeMiterlimit="10" />
      <path d="M41.7703 7.17004C41.7703 7.17004 45.8703 8.11 44.4003 16.13" stroke={outline} strokeMiterlimit="10" />
      <path d="M48.0601 13.0599C48.0601 13.0599 52.7301 18.17 48.5701 29.89" stroke={outline} strokeMiterlimit="10" />
    </g>
  )
}
